import styled from 'styled-components';

const Subtitle = styled.div`
  ${({ theme }) => theme.fontFamily.mainFont.smallExtraBold}
  color: ${({ theme }) => theme.colors.textPrimary};
  line-height: 1.43;
  margin-bottom: 16px;
`;

export default Subtitle;
